import { string } from 'prop-types';
import React from 'react';
import Head from 'next/head';
import { SITE_NAME, SITE_TAGLINE } from 'constants/site';
import { decodeEntities } from 'util/html';

/**
 * createTitleTag() returns a <title /> tag
 *
 * @export
 * @returns {Function} TitleTag component
 */
function createTitleTag() {
  /**
   * outputs a simple title tag, formatting page title and a site name separated
   * by a pipe (vertical bar).
   *
   * if a value matching the site name is provided (which happens on the
   * homepage) or if no value is provided, then use the site name and site
   * tagline separated by a pipe.
   *
   */
  function TitleTag(props) {
    const { value: pageTitle, title: siteTitle, suffix: siteTagline } = props;

    // special case for the homepage
    const fullTitle =
      pageTitle === undefined || pageTitle === siteTitle
        ? `${siteTitle} | ${siteTagline}`
        : `${pageTitle} | ${siteTitle}`;

    return (
      <Head>
        {/*
          React will encode the inner html - decode to avoid double encoding of
          things like `&amp`. We could use `dangerouslySetInnerHTML` instead,
          but this is safer...
        */}
        <title>{decodeEntities(fullTitle)}</title>
      </Head>
    );
  }

  TitleTag.propTypes = {
    value: string,
    title: string,
    suffix: string
  };

  TitleTag.defaultProps = {
    value: undefined,
    title: SITE_NAME,
    suffix: SITE_TAGLINE
  };

  return TitleTag;
}

export default createTitleTag;
